export default "__VITE_ASSET__DecoACFa__"